import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormEditor,
  title: 'Editor',
  category: ComponentCategory.FormControls,
};
